import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom'
import './index.css';
import router from './routes/routes';
import "antd/dist/antd.css";
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { MiddlewareProvider } from './middleware';
import { offsetLimitPagination } from '@apollo/client/utilities';

// import reportWebVitals from './reportWebVitals';

const httpLink = createHttpLink({
  uri: 'https://enkuire.com/dev2/graphql/index.php',
});
const authLink = setContext((_, { headers }) => {

  const token = localStorage.getItem('token');
  // const { token } = useMiddlewareContext() // can't use hooks in authLink apollo function

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <React.StrictMode>
      <MiddlewareProvider>
        <RouterProvider router={router} />
      </MiddlewareProvider>
      {/* <App /> */}
    </React.StrictMode>
  </ApolloProvider>
);

